const wowApp = require('angular').module('wowApp.common');

wowApp.service('RetinaDetectionService', [require('./retina-detection-service')]);

wowApp.service('ImageUrlService', ['Restangular', 'SettingsService', require('./image-url-service')]);

wowApp.component('imgProduct', require('./bws-image-directive'));



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/images/index.js
 **/